import {
    useFetchUserProfile
} from "../../features/profile/profileApi";
import React from "react";
import BannerElement from "./BannerElement";
import AvatarElement from "./AvatarElement";
import ProfileForm from "./ProfileForm";
import BackLink from "../Nav/BackLink";

const ProfileEditContent = () => {
    const { data: profile } = useFetchUserProfile();
    if (!profile) {
        return <></>;
    }

    return (
        <section className="py-2 slide-right">
            <div className="container anim-delay-medium">
                <div className="row slide-top">
                    <div className="col-md-12">
                        <h2 className="text-white text-uppercase mb-1">EDIT PROFILE</h2>
                    </div>
                </div>
                <div className="row slide-bottom">
                    <div className="col-md-12">
                        <BackLink to={`/profile/${profile.name}`} label={'Go back to profile'} />
                    </div>
                </div>
                <div className="row slide-right">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-body">
                                <div className='row mb-2 pop-in'>
                                    <div className='col-12'>
                                        <BannerElement profile={profile}/>
                                    </div>
                                </div>
                                <div className='row mb-2'>
                                    <div className='col-md-4 pop-in'>
                                        <AvatarElement profile={profile}/>
                                    </div>

                                    <div className='col-md-8'>
                                        <ProfileForm profile={profile}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ProfileEditContent;
